const resumeData = {
  firstName: 'Fuad',
  lastName: 'Nasser-Aldeen',
  role: 'Software Engineer',
  avatar:
    'https://avatars.githubusercontent.com/u/26096712?s=400&u=6ca6d2e7c943e33c1c6bdb0a6ad229db4598366a&v=4',
  aboutme1:
    'As a passionate Software Engineer, I am driven to play a key role in all stages of software development, from initial planning to final solution delivery in the digital world. My main objective is to enhance user experiences by leveraging my expertise in software development.',
  aboutme2:
    'I am actively seeking a full-time position in the software development field to contribute my skills and knowledge.',
  address: 'Israel',
  gmail: 'fuad.nasseraldeen@gmail.com',
  roleDescription:
    'I like dabbling in various parts of frontend development and like to learn about new technologies, write technical articles or simply play games in my free time.',
  socialLinks: [
    {
      name: 'linkedin',
      url: 'https://www.linkedin.com/in/fuadnasseraldeen/',
      className: 'fa fa-linkedin',
      img: 'https://img.icons8.com/doodle/40/000000/linkedin--v2.png',
    },
    {
      name: 'github',
      url: 'https://github.com/fuad-nasseraldeen/',
      className: 'fa fa-github',
      img: 'https://img.icons8.com/doodle/40/000000/github--v1.png',
    },
    {
      name: 'instagram',
      url: 'https://www.instagram.com/fuadsami/',
      className: 'fa fa-instagram',
      img: 'https://img.icons8.com/doodle/48/instagram-new.png',
    },
    {
      name: 'whatsapp',
      url: 'https://wa.me/972503955900',
      className: 'fa-brands fa-whatsapp',
      img: 'images/whatsapp.svg',
    },
    {
      name: 'facebook',
      url: 'https://www.facebook.com/fuad.naseraldeen/',
      className: 'fa fa-facebook',
      img: 'https://img.icons8.com/doodle/48/facebook-new.png',
    },
  ],
  education: [
    {
      name: 'Jerusalem College of Engineering (JCE)',
      role: 'B.Sc. Software Engineering',
      MonthOfLeaving: 'Aug',
      YearOfLeaving: '2018',
      MonthOfStarting: 'Jun',
      YearOfStarting: '2014',
      // Achievements: 'Some Achievements',
    },
    // {
    //   // UniversityName: 'Some University',
    //   specialization:
    //     'Private tutor for several courses such as Introduction to Programming in Java, Data Structures, Algorithms, and Probability & Statistics (for college students).',
    //   MonthOfLeaving: 'Aug',
    //   YearOfLeaving: '2018',
    //   MonthOfStarting: 'Jun',
    //   YearOfStarting: '2014',
    //   // Achievements: 'Some Achievements',
    // },
  ],
  work: [
    {
      name: 'Amdocs, Nazareth | Raanana',
      role: 'Software Engineer',
      specialization: [
        [
          'planning and implementing user interfaces using REACTJS. For an account in the Philippines, my role was working in UI as well as joining Business Analysis meetings and Backend planning to deliver most efficient and effective solution.',
        ],
        [
          'Work closely, with customer representatives, to improve the system UX and provide better usability and user experience for both of their agents and end users.',
        ],
        [
          'Developed and maintained new features in modular highly customizable React & Redux based projects',
        ],
        [
          'Identified and fixed bugs/defects in Development/Staging/Production environments, including compiled ES5 code',
        ],
        [
          'Worked in Agile development teams alongside foreign coworkers and assisted new developers with their tasks',
        ],
        [
          'Used enterprise-grade programs/tools such as Teams, Jira, Perforce, Jenkins, Swagger, SonarQube, GitHub',
        ],
      ],
      MonthOfLeaving: 'Jan',
      YearOfLeaving: '2018',
      MonthOfStarting: 'SEPTEMBER',
      YearOfStarting: '2021',
      Achievements: 'Some Achievements',
    },
  ],
  skills: {
    'Programming Languages':
      [

        { value: 'JavaScript', svgId: 'javascript' },
        { value: 'TypeScript', svgId: 'typescript' },
        { value: 'Java', svgId: 'java' },
        { value: 'HTML5', svgId: 'html5' },
        { value: 'CSS', svgId: 'css3' },
        { value: 'SCSS', svgId: 'scss' }
      ],
    'Frameworks & Libraries': [
      { value: 'NodeJS', svgId: 'node-dot-js' },
      { value: 'React', svgId: 'react' },
      { value: 'AngularJS', svgId: 'angular' },
      { value: 'Spring Boot', svgId: 'spring' },
      { value: 'JSP', svgId: 'jsp' },
      { value: 'Bootstrap', svgId: 'bootstrap' },
      { value: 'ExpressJS', svgId: 'express' }
    ],
    Testing: [
      { value: 'Mocha', svgId: 'mocha' },
      { value: 'Chai', svgId: 'chai' }
    ],
    'Front End': [
      { value: 'React', svgId: 'react' },
      { value: 'JavaScript', svgId: 'javascript' },
      { value: 'TypeScript', svgId: 'typescript' },
      { value: 'HTML5', svgId: 'html5' },
        { value: 'CSS', svgId: 'css3' },
        { value: 'SCSS', svgId: 'scss' }
    ],
    'Back End': [
      { value: 'NodeJS', svgId: 'node-dot-js' },
      { value: 'ExpressJS', svgId: 'express' },
      { value: 'REST API', svgId: '' }
    ],
    IDE: [
      { value: 'Visual Studio Code', svgId: 'visualstudiocode' },
      { value: 'Eclipse', svgId: 'eclipseide' }
    ],

    Databases: [
      { value: 'Couchbase', svgId: 'crunchbase' },
      { value: 'MongoDB', svgId: 'mongodb' },
      { value: 'mySQL', svgId: 'mysql' },
      { value: 'PostgreSQL', svgId: 'postgresql' },
      { value: 'Oracle', svgId: 'oracle' },
      { value: 'AWS', svgId: 'amazonaws' }
    ],
    'Programing Tools': [
      { value: 'Jira', svgId: 'jira' },
      { value: 'Perforce', svgId: '' },
      { value: 'Git', svgId: 'git' },
      { value: 'Github', svgId: 'github' },
      { value: 'Jenkins', svgId: 'jenkins' },
      { value: 'Swagger', svgId: 'swagger' },
            { value: 'SublimeText', svgId: 'sublimetext' },
      { value: 'Git', svgId: 'git' },
      { value: 'Gulp', svgId: 'gulp' },
      { value: 'ESLint', svgId: 'eslint' }
    ],
    Deployment: [
      { value: 'Vercel', svgId: 'vercel' },
      { value: 'Firebase', svgId: 'firebase' },
      { value: 'Heroku', svgId: 'heroku' }
    ],
    'Operating System': [
      { value: 'Linux/Unix', svgId: 'linux' },
      { value: 'Windows', svgId: 'windows' },
    ]
    //Web Technologies - Node.js, Express, Web Service (REST), AWS, JSP, Font awesome tailwind  particles.js and axios..
  },
  courses: [
    {
      courseName: 'Java Full Stack Development bootcamp Amdocs & Co-impact',
      monthStartDate: 'Aep',
      yearStartTime: '2020',
      monthEndDate: 'Jan',
      yearEndTime: '2021',
      role: 'backend',
      imgurl: 'img/certifications/co-impact-amdocs-course.jpeg',
      description: [
        [
          'React, Java Core, Advanced Java, Extreme Java, Java 8, Restful API, Spring, Spring Core, Spring Boot, Spring MVC, CSS, HTML, JS, Dockers, K8, Oracle MySQL.',
        ],
        // [
        //   'High emphasis on clean, elegant, maintainable, readable, and efficient code.',
        // ],
      ],
      skills: [
        'React',
        'TypeScript',
        'Java',
        'Spring Boot',
        'Dockers',
        'MySQL',
      ],
    },
    {
      courseName: 'MERN Stack Front To Back: Full Stack React, Redux & Node.js',
      monthStartDate: 'Aep',
      yearStartTime: '2020',
      monthEndDate: 'Jan',
      yearEndTime: '2021',
      role: 'frontend',
      imgurl:
        'img/certifications/MERN-Stack-Front-To-Back-certification.jpg',
      description: [
        [
          'Build and deploy a social network with Node.js, Express, React, Redux & MongoDB.',
        ],
      ],
      skills: ['React', 'TypeScript', 'Redux', 'Express', 'Node.js', 'MongoDB'],
    },
    {
      courseName:
        'React - The Complete Guide (incl Hooks, React Router, Redux)',
      monthStartDate: 'Aep',
      yearStartTime: '2020',
      monthEndDate: 'Jan',
      yearEndTime: '2021',
      role: 'frontend',
      imgurl:
        'img/certifications/React-The-Complete-Guide-certification.jpg',
      description: [
        [
          'Dive in and learn React.js from scratch! Learn Reactjs, Hooks, Redux, React Router.',
        ],
      ],
      skills: ['React', 'TypeScript', 'Hooks', 'Redux', 'React Router'],
    },
    {
      courseName:
        'Full Stack Java developer - Java + JSP + Restful WS + Spring',
      monthStartDate: 'Aep',
      yearStartTime: '2020',
      monthEndDate: 'Jan',
      yearEndTime: '2021',
      role: 'backend',
      imgurl: 'img/certifications/Full-Stack-Java-developer.jpg',
      description: [
        [
          'Core Java + JSP Servlets + Hibernate +Spring + Java Web-service/RestFul API + Spring boot.',
        ],
      ],
      skills: ['Java', 'Spring Boot', 'Restful API'],
    },
    {
      courseName: 'Go Java Full Stack with Spring Boot and Angular',
      monthStartDate: 'Aep',
      yearStartTime: '2020',
      monthEndDate: 'Jan',
      yearEndTime: '2021',
      role: 'backend',
      imgurl:
        'img/certifications/Go-Java-Full-Stack-with-Spring-Boot-and-Angular.jpg',
      description: [
        ['Full Stack Web Development with Angular and Spring Boot.'],
      ],
      skills: ['Angular', 'Spring Boot', 'Node.js'],
    },
  ],
  projects: [
    {
      name: 'Coupon System Project',
      description:
        'The Coupon System Project acts as a Micro Service that shows an implementation which allows companies to CRUD coupons for their customers. then the Customers can purchase and use those Coupons, and get a discount in that company "business".',
      frameworks: [
        {
          name: 'React',
          color: '#0062B1',
        },
        {
          name: 'Springboot',
          color: '#d6a514',
        },
        {
          name: 'MongoDB',
          color: '#5465ff',
        },
      ],
      imgurll: 'images/projects/coupon4.png',
      imgurl: 'https://i.ibb.co/4PSB3C7/coupon4.png',
      // imgurl: [
      //   'images/projects/coupon4.png',
      //   'images/projects/coupon3.png',
      //   'images/projects/coupon2.png',
      //   'images/projects/coupon1.png',
      // ],
      giturl: 'https://github.com/fuadsami/Coupon-System-e2e/tree/master',
      demourl:
        'https://drive.google.com/file/d/1TToplikGBfuBI9rdIi9i3UAG0hg69S5i/view?usp=sharing',
      readme: 'https://github.com/fuadsami/Coupon-System/blob/main/README.md',
    },
    {
      name: 'Social network for developers',
      description:
        'Its a small social network app that includes authentication, profiles and forum posts, like/dislike a post and comment on a post.',
      frameworks: [
        {
          name: 'React',
          color: '#0062B1',
        },
        {
          name: 'material ui',
          color: '#d6a514',
        },
        {
          name: 'MongoDB',
          color: '#5465ff',
        },
      ],
      imgurll: 'images/projects/Social-network-for-developers.png',
      imgurl: 'https://i.ibb.co/hdxPLqj/Social-network-for-developers.png',
      giturl:
        'https://github.com/fuad-nasseraldeen/social-network-for-developers/blob/main/README.md',
      demourl: 'https://social-network-fuad.herokuapp.com/',
    },
    {
      name: 'Calculating Percolation Program',
      description:
        'calculate for a network of any size with any number and order of resistors, the possible electrical conductivity values and the probability of obtaining any such value. My role was to build the GUI section.',
      frameworks: [
        {
          name: 'Java',
          color: '#0062B1',
        },
        {
          name: 'JST',
          color: '#d6a514',
        },
      ],
      imgurll: 'images/projects/Calculating-Percolation-Program.png',
      imgurl: 'https://i.ibb.co/0ykZZDb/Calculating-Percolation-Program.png',
      giturl:
        'https://github.com/fuad-nasseraldeen/percolation/blob/main/README.md',
      demourl:
        'https://drive.google.com/file/d/1qCGgzXlEeoACFUFToULOBxWoCKY6Lrhf/view?usp=sharing',
    },
    {
      name: 'Salametcom',
      description:
        'calculate for a network of any size with any number and order of resistors, the possible electrical conductivity values and the probability of obtaining any such value. My role was to build the GUI section.',

      descriptiddon:
        'web application for the organization to help organize and manage them and their volunteer’s work.',
      frameworks: [
        {
          name: 'Node.js',
          color: '#0062B1',
        },
        {
          name: 'Jade Template engine',
          color: '#d6a514',
        },
      ],
      imgurll: 'images/projects/salametcom.png',
      imgurl: 'https://i.ibb.co/XsnHhjT/salametcom.png',
      giturl: 'https://github.com/ZeinaAbuSwai/Salametcom',
    },
  ],
  hobbies: [
    'Playing Games',
    'Swimming/GYM',
    'Travelling',
    'Ride hourses',
    'solve sudoko',
  ],
  hackathonMemoriesTemp: [
    'images/hackathon-memories/hackathonCertificationFuad.png',
    'images/hackathon-memories/hackathon-amdocs3.jpeg',
    'images/hackathon-memories/hackathon-amdocs1.jpeg',
    'images/hackathon-memories/hackathon-amdocs2.jpeg',
    'images/hackathon-memories/hackathon-amdocs4.jpeg',
    'images/hackathon-memories/hackathon-amdocs5.jpeg',
    'images/hackathon-memories/hackathon-amdocs7.jpg',
    'images/hackathon-memories/hackathon-amdocs8.jpg',
    'images/hackathon-memories/hackathon-amdocs9.jpg',
    'images/hackathon-memories/hackathon-amdocs10.jpg',
    'images/hackathon-memories/hackathon-amdocs17.jpg',
    'images/hackathon-memories/hackathon-amdocs22.jpg',
    'images/hackathon-memories/hackathon-amdocs23.jpg',
    'images/hackathon-memories/hackathon-amdocs24.jpg',
  ],
  hackathonMemories: [
    'https://i.ibb.co/2Mhvk9B/hackathon-Certification-Fuad.png',
    'https://i.ibb.co/v4775z6/hackathon-amdocs3.jpg',
    'https://i.ibb.co/G3nxD6r/hackathon-amdocs1.jpg',
    'https://i.ibb.co/7jnQ4kP/hackathon-amdocs2.jpg',
    'https://i.ibb.co/W3hXNdk/hackathon-amdocs4.jpg',
    'https://i.ibb.co/Bs542dY/hackathon-amdocs5.jpg',
    'https://i.ibb.co/fDn2G74/hackathon-amdocs7.jpg',
    'https://i.ibb.co/BV0ySS9/hackathon-amdocs8.jpg',
    'https://i.ibb.co/C29Pk7L/hackathon-amdocs9.jpg',
    'https://i.ibb.co/8zcKVKb/hackathon-amdocs10.jpg',
    'https://i.ibb.co/V32qB7g/hackathon-amdocs17.jpg',
    'https://i.ibb.co/j3vgHFf/hackathon-amdocs22.jpg',
    'https://i.ibb.co/smyhyrv/hackathon-amdocs23.jpg',
    'https://i.ibb.co/n8xpZpf/hackathon-amdocs24.jpg',
  ],
  recommendations: [
    {
      avatar:
        'https://media.licdn.com/dms/image/C5603AQGeJ5GFPCuBXw/profile-displayphoto-shrink_800_800/0/1588529531355?e=1703116800&v=beta&t=9g0oGxyCdFsOtOb1wniE7g1jtGdXMX4XrpJE_q-9ggY',
      description: [
        'I am writing to provide a recommendation for Fuad Nasser Aldeen based on my experience working with him as the Director of Software Engineering at Amdocs. Fuad was a valuable member of our team for about 14 months (2021 – 2022), and I had the opportunity to closely observe his skills and contributions during this period.',
        'Fuad consistently demonstrated excellent technical expertise and a strong commitment to his work. He took on various UI projects, specializing in technologies such as React, JavaScript, CSS, and other tools like SSO. I found Fuad to be a dedicated and motivated individual who always gave his best effort. He approached his tasks with thorough investigation and went beyond just implementing the required functionality. Fuad actively sought ways to enhance existing features and improve overall system performance.',
        "Fuad's dedication to delivering high-quality work and his proactive approach to problem-solving were instrumental in the success of our projects. He consistently demonstrated a strong sense of ownership and accountability, going above and beyond to ensure the team's objectives were met. His positive attitude and willingness to support his colleagues created a positive work atmosphere and enhanced overall team productivity.",
        'I received outstanding feedback from colleagues who worked closely with Fuad. His technical proficiency, motivation, and pleasant demeanor made him a pleasure to work with. I have no hesitation in recommending Fuad Nasser Aldeen as a highly skilled and reliable Software Developer. He is an exceptional individual who adds value to any team or project he is a part of.',
        "Should you have any further questions or require additional information, please do not hesitate to reach out to me. I would be more than happy to provide further insights into Fuad's abilities and accomplishments.",
      ],
      linkedinUrl: 'https://www.linkedin.com/in/nemer-naarany-4b1368b5/',
      role: 'Director Of Software Engineering at Amdocs',
      name: 'nemer naarany',
      source: '',
    },
    {
      avatar:
        'https://media.licdn.com/dms/image/C4D03AQGyE0dEh8Kg8Q/profile-displayphoto-shrink_800_800/0/1556482884426?e=1703116800&v=beta&t=s7fd8Yg9qlNvraTc2tUqsAVPRYjMp5PtrMpgXnjadSA',
      description: [
        'I managed Fuad for a bit more than a year. In my team. he worked in UI area, mainly in React, JS, CSS and with other tools that we used like SSO and more.',
        'During this year I found him a hard worker and a very motivated person. When he got a task, he did it the best he could. he did deep investigation, and he tried not only to implement his task, but also to improve the existing functionality he touched.',
        'He learned a lot during the last year, and his knowledge in UI grew considerably. Fuad was a team person, very committed, smart, motivated and very pleasant to work with',
      ],
      linkedinUrl: 'https://www.linkedin.com/in/sameh-halabi-66182880/',
      role: 'Software Development Manager',
      name: 'sameh halabi',
      source: '',
    },
    {
      avatar:
        'https://media.licdn.com/dms/image/C4D03AQE90FY7Gq5eUg/profile-displayphoto-shrink_800_800/0/1658750394658?e=1703116800&v=beta&t=oa3QifDq6wSjYYgCpCGN7mX99D6-kk1uPtuQa7DQs-c',
      description: [
        "It was a real pleasure working with Fuad Nasser Aldeen as a Software Developer for about 14 months (2021 – 2022) being his team's Software Technical Expect at Amdocs Israel.",
        ' During the mentioned period Fuad has shown excellent technical skills, high professionalism and positive atitude, and proved to be highly motivated, hard-working individual who consistently arrives on time, and shows great dedication towards his professional duties.',
        " Fuad is a team player, always looking to expand his skill set and willing to assist and share the knowledge with his teammates, and other team's members.",
        ' I consistently received a great feedback from the people who worked with him, we would be happy to have him again in our future projects, as he has proven himself as an asset and very valuable member for the project and his team members.',
      ],
      linkedinUrl: 'https://www.linkedin.com/in/rimon-sliman-7b64b71b5/',
      role: 'Software Technical Expert at Amdocs',
      name: 'rimon sliman',
      source: './Recommendation-Letter-Rimon.pdf',
    },
    {
      avatar:
        'https://media.licdn.com/dms/image/D4D03AQGmoaZOxGcYPQ/profile-displayphoto-shrink_800_800/0/1686821829694?e=1703116800&v=beta&t=y5ZVa3mDMG2hH8RtiIpEUxpWiX7X0FNMoZ3AQBhde0c',
      description: [
        'I highly recommend Fuad as an exceptional front-end developer. I had the pleasure of working with him at Amdocs, where he showcased impressive skills in React and TypeScript.',
        'Fuad proved that he can consistently delivering top-notch code. He has a strong command of React and TypeScript, and his ability to create efficient and elegant solutions is remarkable.',
        'With a keen eye for detail and a commitment to clean coding practices, Fuad consistently delivered high-quality work. he was a valuable team member, effectively collaborating with colleagues and communicating ideas.',
        'I wholeheartedly recommend Fuad to any organization in need of a talented front-end developer proficient in React and TypeScript.',
      ],
      linkedinUrl: 'https://www.linkedin.com/in/najeh-tahhan-752641145/',
      role: 'Software Engineer at Amdocs',
      name: 'najeh tahan',
      source: '',
    },
    {
      avatar:
        'https://media.licdn.com/dms/image/D4D35AQF6UR37GT8gbA/profile-framedphoto-shrink_800_800/0/1695647691111?e=1698328800&v=beta&t=JAC2KHe1o8sp7pBXS82UkARYNndp265ECnW4Zfo6laA',
      description: [
        'We worked together on End to End tasks, where Fuad was part of the frontend developers, and I was part of the backend developers, and working together was very easy, communication was on point, and Fuad was always quick to respond.',
        'Fuad is very dedicated, serious about his work, and always does his homework before voicing his opinion or before approaching a task, which is something I really liked about him.',
        'I totally recommend Fuad.',
      ],
      linkedinUrl: 'https://www.linkedin.com/in/tamer-aamas-60359610a/',
      role: 'Software Engineer at Amdocs',
      name: 'Ebrahem Droobi',
      source: '',
    },
    {
      avatar:
        'https://media.licdn.com/dms/image/C4D03AQFE8tVXri6tFg/profile-displayphoto-shrink_800_800/0/1646142742840?e=1703116800&v=beta&t=jFtxVCTQtBdSIJm6IcpbU3S_sUH3dvaY5K5Y6ut_zJQ',
      description: [
        "I'm pleased to share my experience working with Fuad. We worked on UI projects together.",
        'Fuad excels at working in a team environment and is a professional under pressure. He maintains his composure and focus while working under pressure and meeting deadlines, producing excellent outcomes.',
        'Additionally, he is highly organized, always having a strategy in place and keeping on top of everything. ',
        'Fuad is a pleasant and personable person personally, which makes working together simple. His constant willingness to provide a hand to his coworkers fosters a supportive and innovative workplace.',
      ],
      linkedinUrl: 'https://www.linkedin.com/in/tamer-aamas-60359610a/',
      role: 'Software Engineer at Amdocs',
      name: 'tamer aamas',
      source: '',
    },
    {
      avatar:
        'https://media.licdn.com/dms/image/C4D03AQESRZ78u0sAfg/profile-displayphoto-shrink_800_800/0/1580113108524?e=1703116800&v=beta&t=jDSdNZeHZ9H6gkU83fkg2Ni7PV0Ns8EspXA2KVMxSl4',
      description: [
        'I had the opportunity to work with Fuad Nasser-Aldeen for the whole period he worked at Amdocs, what I saw is a dedicated, fast learner and responsible team player. I noticed that from the first few days, he always meet the expectations and I found him as the member we all know that he will do the best job.',
        'Fuad showed a good developing skills in JavaScript, CSS and debugging.',
      ],
      linkedinUrl: 'https://www.linkedin.com/in/ammar-krayem-42b66ba1/',
      role: 'UI Developer at Amdocs',
      name: 'Ammar Krayem',
      source: '',
    },
  ],
}

export type ResumeData = typeof resumeData;
export default resumeData;
